<template>
   <v-layout align-start>
        <v-flex>

<v-container class="ma-0 pa-0" >
    <v-row no-gutters >
         <v-col  lg="4">          
              
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-text-field @keyup.enter="barcodeAction()" 
                    v-model="barcode" 
                    label="Escanea" 
                    :disabled="dialogLoading"
                    :loading="dialogLoading"
                    required></v-text-field> 
                </v-flex>
                     
                
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-select v-model="areaItem" 
                    :items="areaItems" label="Area" 
                    item-text="area"
                    item-value="id_area"
                    filled > </v-select>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-select v-model="lineItem" 
                    :items="lineItems" label="Tipo de linea"
                     item-text="linetype"
                    item-value="id_line" 
                    filled > </v-select>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-select v-model="stationItem" :items="stationItems" label="Estacion" filled > </v-select>
                </v-flex>
                
                
                <v-switch
                    v-model="cycle"
                    label="Auto"
                    inset
                ></v-switch>    
                
                <v-container  >
                    <v-row  align-v="center">
                        <v-col  lg="12" align="center" max-height="100%">                            
                            
                            <p style="margin: 0;fontSize: 110px" >{{model+1}}/{{itemSOP.length}}</p>
                        </v-col>
                    </v-row>
                </v-container> 
             
               
         </v-col>
         <v-col  lg="8">
            <v-card
                elevation="24"
                max-width="85%"
                class="mx-auto"
            >
                <v-system-bar lights-out></v-system-bar>

            <v-carousel
                cycle
                height="100%"
                hide-delimiter-background
                show-arrows-on-hover
                :cycle="cycle"
                v-model="model"
            >
                

                <v-carousel-item
                v-for="(item,i) in itemSOP"
                :key="i"
                >
                <!-- <v-sheet       
                    height="100%"
                >-->
                    <v-row
                    class="fill-height"
                    align="center"
                    justify="center"
                    >
                   
                      <v-img
                        :src="item.img_path"
                        height="100%"
                        class="grey darken-4"
                        ></v-img>
                    
                    </v-row>
                <!--</v-sheet>-->
                </v-carousel-item>  


            </v-carousel>

            </v-card>
         </v-col>
    </v-row>
</v-container>



 
</v-flex>
</v-layout>
</template>

<script>    
    import axios from 'axios'; 
    import moment from 'moment'; 
   
    export default{
        components: {
                     
        },       
        data (){
            return {
                  moment:moment,                
                  partnoAlt:[],                  
                  dialog: false,
                  dialogLoading: false,
                    headers: [
                        { text: 'Actions', value: 'action', sortable: false },                        
                       // { text: 'ID', value: 'id', sortable: false },
                        { text: 'Area', value: 'area', sortable: false },
                        { text: 'Description', value: 'description', sortable: false },                        
                        { text: 'State', value: 'condition', sortable: false }                      
                    ],
                    //moment: moment, // Set to whatever
                    //privileges: false,
                    //urlBase:'',
                    itemSOP:[],
                    items: [
                        
                        { src: 'http://10.13.8.220/dfmsApplications/Imagen/1/111.gif', },
                        { src: 'http://10.13.8.220/dfmsApplications/Imagen/1/Slide1.JPG',},
                        {
                                src: 'http://10.13.8.220/dfmsApplications/Imagen/1/Slide2.JPG',
                            },
                            {
                                src: 'http://10.13.8.220/dfmsApplications/Imagen/1/Slide3.JPG',
                            },
                            {
                                src: 'http://10.13.8.220/dfmsApplications/Imagen/1/Slide4.JPG',
                            },
                            {
                                src: 'http://10.13.8.220/dfmsApplications/Imagen/1/Slide5.JPG',
                            },
                            {
                                src: 'http://10.13.8.220/dfmsApplications/Imagen/1/Slide6.JPG',
                            },
                            {
                                src: 'http://10.13.8.220/dfmsApplications/Imagen/1/Slide7.JPG',
                            },
                            {
                                src: 'http://10.13.8.220/dfmsApplications/Imagen/1/Slide8.JPG',
                            },
                            {
                                src: 'http://10.13.8.220/dfmsApplications/Imagen/1/Slide9.JPG',
                            },
                            {
                                src: 'http://10.13.8.220/dfmsApplications/Imagen/1/Slide10.JPG',
                            },
                            
                        ],
                    cycle: false,
                    model: 0,
                    barcode: '',
                    colors: [
                        'indigo',
                        'warning',
                        'pink darken-2',
                        'red lighten-1',
                        'deep-purple accent-4',
                        ],
                        slides: [
                        'First',
                        'Second',
                        'Third',
                        'Fourth',
                        'Fifth',
                        ],

                    areaItem: '',
                    lineItem:'',             
                    stationItem: '',
                    areaItems: [],
                    lineItems: [],
                    stationItems: ['1','2','3','4','5','6','7','8','9','10',
                    '11','12','13','14','15','16','17','18','19','20',
                    '21','22','23','24','25','26','27','28','29','30',
                    '31','32','33','34','35','36','37','38','39','40',
                    '41','42','43','44','45','46','47','48','49','50'], 
                    
                    search: '',
                    desserts: [],
                    editedIndex: -1,
                  
                    id: '', 
                    part_number: '', 
                    part_number_alt: '', 
                    create_dt: '', 
                                      
                   
                    valida:0,
                    validaMensaje:[],

                    adModal: 0,
                    adAccion: 0, 
                    adName: '',
                    adId: '',

                    area: '',
                    description: '' 

                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Area' : 'Edit Area'
            },
                          
        },

        watch: {
            dialog (val) {
            val || this.close()
            } ,
             dialogLoading (val)  {
                if (!val) return
            }          
        },

        created () {
            this.initialize();
            this.listArea();
            this.listLinetype();
            //this.havePriviges(); 
            //this.urlBase = this.$sopURL; 
            //console.log( 'Base 555' ,this.urlBase);    
        },

         methods: { 
           //   havePriviges() {
            //    this.$store.state.user.rol === "yms_customs" ? this.privileges =false : this.privileges =true
            //} ,   
            barcodeAction(){ 
                if (this.barcode.toLowerCase().trim() == "next")
                {
                    this.model++;
                }
                if (this.barcode.toLowerCase().trim() == "back")
                {
                    this.model--;
                }
                if (this.barcode.toLowerCase().trim() == "end")
                {
                    this.model = this.itemSOP.length-1;
                }
                if (this.barcode.toLowerCase().trim() == "start")
                {
                    this.model = 0;
                }
                if (this.barcode.toLowerCase().trim() == "cycle")
                {
                    this.cycle = !this.cycle;                   
                }

                 if (this.barcode.toLowerCase().trim() != "next"
                    && this.barcode.toLowerCase().trim() != "back"
                    && this.barcode.toLowerCase().trim() != "end"
                    && this.barcode.toLowerCase().trim() != "start"
                    && this.barcode.toLowerCase().trim() != "cycle"
                    )
                {
                    //2SWJ853  Buscar la ayuda visual que esta promovida 

                    console.log(this.barcode.toUpperCase().trim());
                    this.sopList();    
                }
                

                this.barcode = '';
            },
             exitApp(){
                this.$store.dispatch("exit");
            }, 
            sopList(){
                 
                   

                     let me=this; 
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token                       
                        };  
                   
                    let configuration = {headers : header };
                    this.dialogLoading = true;   
                   
                    axios.post('api/dell_sop_d_document_master/productionSOP',{                                                   
                            'ssn': this.barcode.toUpperCase().trim(),
                            'id_area': me.areaItem,
                            'id_line': me.lineItem,
                            'station_no': me.stationItem      
                    },configuration).then(function(response){
                      
                        me.itemSOP = response.data;  
                        console.log( me.itemSOP);                     
                       
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoading  = false,
                        this.validaMensaje.push('Area is already registered.')
                    );  

                console.log('End');

            },

            listArea(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_area/ActiveList';               
                axios.get(url,configuration).then(function(response){                   
                    me.areaItems = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            listLinetype(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_line_type/ActiveList';               
                axios.get(url,configuration).then(function(response){                   
                    me.lineItems = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            
            initialize () {                            
            },
            
            editItem (item) {
                                               
                this.id= item.id_area;  
                this.area= item.area; 
                this.description= item.description; 
                this.condition= item.condition;
                      
                this.editedIndex=1;
                this.dialog = true
            },

            activeDesactiveItem (accion, item) {
                this.adModal= 1;
                this.adName = item.area;
                this.adId = item.id_area;

                if (accion == 1){
                   this.adAccion = 1;
                } else if (accion == 2){
                    this.adAccion = 2;
                } else{
                   this.adModal= 0;
                }                
            },

            activateDesactivateClose(){
                this.adModal = 0;
            },

            activate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_area/Activate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listArea();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },
            deactivate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_area/Desactivate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listArea();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },

            close () {
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
            clean() {               

                this.id= ""; 
                this.area= "";
                this.description= "";
                this.condition= ""; 
                  

                this.editedIndex=-1;

                this.valida= 0;
                this.validaMensaje= [];

            },           
          
            save () {               
                if (this.validar() > 0)  {                                      
                     return;   
                }                 
                
                if (this.editedIndex > -1) {                   
                   //Code for Edit Mode
                   this.dialogLoading = true;
                   let me=this;

                     let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token                       
                        };

                   //let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_area/Update',{                                                   
                        'id_area':me.id,                                         
                        'area': me.area,
                        'description': me.description                            
                    },configuration).then(function(response){
                        me.close();
                        me.listArea();
                        me.clean();
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);                   

                } else {                    
                    //Code for Save                   
                   if (this.validar()){
                       return;
                   }

                    let me=this; 
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token                       
                        };   
                    //let header={"Authorization": "Bearer " + this.$store.state.token};
                    let configuration = {headers : header };
                    this.dialogLoading = true;         
                    axios.post('api/dell_sop_s_area/CreateArea',{                                                   
                            'area': me.area,
                             'description': me.description     
                    },configuration).then(function(response){
                        console.log('Save');
                        me.close();
                        me.listArea();
                        me.clean();
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoading  = false,
                        this.validaMensaje.push('Area is already registered.')
                    );  
                   
                }               
            },
           
            validar() {
                 this.valida=0;
                 this.validaMensaje=[];
                 
                 if (!this.area){
                     this.validaMensaje.push('Input area');
                 }   
                 if (!this.description){
                     this.validaMensaje.push('Input description');
                 }
                  
                 if (this.validaMensaje.length){
                    this.valida=1;                    
                }                                             
                 return this.valida;
            },
        },
    }
</script>